import React from 'react';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import FontAwesomeIcon from 'src/components/Icon';
import useWalkthroughSyncSuspendEnable from 'src/SharedCustomHooks/UseWalkthroughSyncSuspendEnable/useWalkthroughSyncSuspendEnable';
import './WalkthroughSyncCell.scss';

interface WalkthroughSyncCellProps {
  propertyId: string;
  syncAutomationSuspended: boolean;
  onToggleSuccess: (propertyId: string, newSuspendedState: boolean) => void;
}

const WalkthroughSyncCell = ({
  propertyId,
  syncAutomationSuspended,
  onToggleSuccess,
}: WalkthroughSyncCellProps) => {
  const {
    isTogglingSuspend,
    isConfirmModalOpen,
    openSuspendConfirmModal,
    closeConfirmModal,
    confirmSuspendAction,
    confirmModalProps,
  } = useWalkthroughSyncSuspendEnable(propertyId, syncAutomationSuspended, onToggleSuccess);

  return (
    <>
      <div className="walkthrough-sync-suspend">
        <span className="walkthrough-sync-suspend-label">
          {syncAutomationSuspended ? 'Enable Automation' : 'Disable Automation'}
        </span>
        <button
          className="walkthrough-sync-suspend-btn"
          onClick={openSuspendConfirmModal}
          disabled={isTogglingSuspend}
          title={syncAutomationSuspended ? 'Enable Walkthrough Sync Automation' : 'Disable Walkthrough Sync Automation'}
        >
          <FontAwesomeIcon
            glyph={syncAutomationSuspended ? 'play-circle' : 'pause-circle'}
            weight="solid"
          />
        </button>
      </div>
      {isConfirmModalOpen && (
        <ConfirmationModal
          title={confirmModalProps.title}
          message={confirmModalProps.message}
          confirmLabel={confirmModalProps.confirmLabel}
          cancelLabel={confirmModalProps.cancelLabel}
          variant={confirmModalProps.variant}
          requireTypeToConfirm={confirmModalProps.requireTypeToConfirm}
          confirmationWord={confirmModalProps.confirmationWord}
          onConfirm={confirmSuspendAction}
          onCancel={closeConfirmModal}
          isSubmitting={isTogglingSuspend}
        />
      )}
    </>
  );
};

export default WalkthroughSyncCell;